<template>
  <div>
    <div class="jumbotron">
      <div class="mask org"></div>
      <b-row class="pt-5 text-left text-white" style="margin: auto;">
        
        <b-col cols="4" md="2" class="text-right">
          <b-img src="/iconss/organizzazioni.png" class="rounded-pill bg-white text-center p-2"></b-img>
        </b-col>
        
        <b-col cols="4" class="">
          <h2>Organizzazioni</h2>
          <p>Area riservata</p>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <b-col lg="12" class="text-left">
        <h2>Inserisci qui il documento che vuoi tradurre.</h2>
        <div class="black-box pl-1">
          <b-overlay :show="loading" rounded="sm">
            <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
              <b-row>
                <b-col lg="4">
                  <label class="d-flex">
                    <b-iconstack font-scale="4">
                      <b-icon stacked icon="circle-fill" variant="primary"></b-icon>
                      <b-icon stacked icon="circle" variant="white" scale="0.5"></b-icon>
                      <b-icon stacked icon="arrow-up" scale="0.45" variant="white"></b-icon>
                    </b-iconstack>

                    <b-form-file
                      class="d-none"
                      :state="Boolean(file)"
                      ref="file"
                      v-model="file"
                      @change="onFileChange"
                      required
                      placeholder="* Trascina o Seleziona il file da tradurre"
                    />
                    <div class="d-flex my-auto ml-3">
                      <input
                        type="text"
                        class="form-control btn-outline-primary rounded-pill"
                        ref="viewFile"
                        @click="$refs.file.$el.click()"
                        aria-describedby="button-addon2"
                      />
                      <button
                        class="btn btn-primary butFile pl-4"
                        type="button"
                        @click="$refs.file.$el.click()"
                        id="button-addon2"
                      >
                        <small><strong>SELEZIONA</strong></small>
                      </button>
                    </div>
                  </label>
                </b-col>
                <b-col lg="2"></b-col>
                <b-col lg="5">
                  <small>
                    È consigliato caricare documenti in formato Word (Doc, Docx) oppure Excel o Powerpoint.
                    <br />È possibile caricare anche documenti in formato PDF e JPG, in tali casi tuttavia tenere in
                    considerazione che questi tipi di documento richiedono una completa trascrizione da parte dei
                    traduttori, causando tempi di consegna più lunghi.
                  </small>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col sm="6">
                  <!-- new type of documents select -->
                  Tipo documento
                  <v-select
                    v-validate="'required'"
                    v-model="document_type"
                    :options="type_of_documents"
                    placeholder="Seleziona documento (legale, medico, ecc.)"
                    name="document_type"
                    label="description"
                  ></v-select>
                  <span class="text-danger">{{ errors.first("document_type") }}</span>
                </b-col>
                <b-col sm="6">
                  Entro quale data ti serve la traduzione?
                  <br />
                  <date-picker
                    :lang="langPicker"
                    v-model="due_date"
                    type="date"
                    :input-attr="{
                      name: 'due_date',
                      id: 'due_date',
                      required: 'true',
                    }"
                  ></date-picker>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col sm="6">
                  Lingua originale del documento
                  <v-select
                    required
                    :options="langs"
                    v-model="src_lang"
                    label="description"
                    :input-attr="{ name: 'src_lang', id: 'src_lang' }"
                  ></v-select>
                  <span class="flag">{{ src_lang.flag }}</span>
                </b-col>
                <b-col sm="6">
                  Lingua in cui serve tradurlo
                  <v-select
                    multiple
                    v-validate="'required'"
                    :options="langs"
                    v-model="dest_lang"
                    label="description"
                    name="dest_lang"
                    @input="changedLabel"
                  ></v-select>

                  <!-- <span class="text-danger">{{ errors.first("dest_lang") }}</span> -->
                  <span v-for="(item, index) in dest_lang" :key="index">
                    <span class="flag">{{ item.flag }}</span>
                  </span>

                  <b-form-checkbox name="request_audio" v-model="request_audio">
                    <b-icon-music-note></b-icon-music-note>
                    Richiedo oltre alla traduzione scritta, anche un file audio della traduzione registrato in lingua.
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <br>
                  <p>
                  Non trovi la lingua che ti serve?<br>
                  Contattaci a <a href = "mailto:info@languageaid.org?subject=Richiesta Traduzione">info@languageaid.org</a> e faremo il possibile per trovare le risorse necessarie a completare la tua traduzione.
                  </p>
              <hr />
              <div class="m-2">
                <b-form-textarea
                  id="textarea"
                  v-model="note"
                  placeholder="Note / Osservazioni per i traduttori"
                  rows="2"
                  max-rows="3"
                  name="note"
                ></b-form-textarea>
              </div>
              <div class="m-2">
                <b-button type="submit" variant="primary" :disabled="loading" pill
                  ><small><strong>INVIA</strong></small></b-button
                >
                <hr class="border-danger" />
              </div>
              <b-alert :show="errorMessage.length" variant="danger">{{ errorMessage }}</b-alert>
            </b-form>
          </b-overlay>
        </div>
        <!-- <hr class="border-danger" /> -->
      </b-col>
    </b-row>
    <b-row class="d-flex justify-content-around m-2 mx-auto" style="max-width: 1460px">
      <b-col lg="6" class="pr-4 text-left">
        <b-row>
          <b-col>
            <h2>Richieste in corso</h2>
          </b-col>
          <b-col class="text-right">
            <b-dropdown id="dropdown-form" text="Ordina" variant="outline-secondary" ref="dropdown" class="m-2" size="sm">
              <b-dropdown-form>
                
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="src_lang_id">Lingua sorgente</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="dest_lang_id">Lingua di destinazione</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="name">Nome del documento originale</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="document_type">Tipo di documento</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="due_date">Data di scadenza</b-form-radio>
                </b-form-group>
                <b-dropdown-divider></b-dropdown-divider>
                <b-form-group v-slot="{ ariaDescribedby2 }">
                  <b-form-radio v-model="asc" :aria-describedby="ariaDescribedby2" name="some-radios2" value="ASC" active>Crescente</b-form-radio>
                  <b-form-radio v-model="asc" :aria-describedby="ariaDescribedby2" name="some-radios2" value="DESC">Decrescente</b-form-radio>
                </b-form-group>
                <b-button variant="primary" size="sm" @click="order('queue',true)">Cerca</b-button>
                <b-button variant="outline-danger" size="sm" @click="order('queue',false)">Cancella</b-button>
              </b-dropdown-form>
            </b-dropdown>
          </b-col>
        </b-row>
        
        
        <b-row v-if="queue.length">
          <b-col cols="12" v-for="(item, index) in queue" :key="item.id" :ref="'card-queue' + item.id">
            <card-org1 :item="item" :index="index" :status="status"></card-org1>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>Nessuna richiesta in coda</b-col>
        </b-row>
      </b-col>
      <b-col lg="6" class="pr-4 text-left">
        <b-row>
          <b-col class="text-left">
            <h2>Richieste completate</h2>
          </b-col>
          <b-col class="text-right">
            <b-dropdown id="dropdown-form2" text="Ordina" variant="outline-secondary" ref="dropdown2" class="m-2" size="sm">
              <b-dropdown-form>
                
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="src_lang_id">Lingua sorgente</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="dest_lang_id">Lingua di destinazione</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="name">Nome del documento originale</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="document_type">Tipo di documento</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="due_date">Data di scadenza</b-form-radio>
                </b-form-group>
                <b-dropdown-divider></b-dropdown-divider>
                <b-form-group v-slot="{ ariaDescribedby2 }">
                  <b-form-radio v-model="asc" :aria-describedby="ariaDescribedby2" name="some-radios2" value="ASC" active>Crescente</b-form-radio>
                  <b-form-radio v-model="asc" :aria-describedby="ariaDescribedby2" name="some-radios2" value="DESC">Decrescente</b-form-radio>
                </b-form-group>
                <b-button variant="primary" size="sm" @click="order('completed',true)">Cerca</b-button>
                <b-button variant="outline-danger" size="sm" @click="order('completed',false)">Cancella</b-button>
              </b-dropdown-form>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row v-if="complete.length">
          <b-col cols="12" v-for="item in complete" :key="item.id">
            <card-org2 :item="item"></card-org2>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>Nessuna richiesta completata</b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <b-button variant="primary" pill to="/organizations/archivio" size="lg"
        ><small><strong>VISUALIZZA TUTTO</strong></small></b-button
      ></b-col>
    </b-row>

    <b-modal id="only-automatic-translate" title="Attenzione" hide-footer>
      <b-row>
        <b-col cols="12">
          <p class="text-left">
            La lingua selezionata è disponibile solo in traduzione automatica. Per richiedere una traduzione
            rivista da un volontario contattateci a <b>info@languageaid.org</b> e faremo il possibile per trovare le
            risorse necessarie.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-button class="mt-3" style="margin-left: auto; margin-right: auto;" variant="primary" block @click="$bvModal.hide('only-automatic-translate')">Ok</b-button>
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/it";
import Util from "@/mixing/util";
import CardOrg1 from "@/components/CardOrg1";
import CardOrg2 from "@/components/CardOrg2";
import moment from "moment";
import UserService from "@/services/user.service";
import authFileHeader from "@/services/auth-header";
import authHeader from "@/services/auth-header";

export default {
  mixins: [Util],
  components: { DatePicker, CardOrg1, CardOrg2 },
  computed: {
    document_typeState() {
      let n = this.document_type.length;
      return n < 20 ? null : false;
    },
  },
  data() {
    return {
      langPicker: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      loading: false,
      file: [],
      requester_id: null,
      document_type: "",
      type_of_documents: [
        "Generico",
        "Legale",
        "Brochure/promozione",
        "Sanitario/Medico",
        "Sociale/sindacale",
      ] /* type document select */,
      due_date: "",
      src_lang_id: "it",
      dest_lang_id: [],
      note: "",
      src_lang: "Italiano",
      dest_lang: [],
      langs: [],
      queue: [],
      user: [],
      complete: [],
      status: [],
      errorMessage: "",
      request_audio: 0,
      app: [],
      orderBy: null,
      asc: 'ASC',
    };
  },
  created() {
    UserService.getLanguages().then((response) => (this.langs = response.data));

    UserService.getStatus().then((response) => (this.status = this.getMap(response.data)));

    UserService.whoAmI()
      .then((response) => (this.user = response.data))
      .catch((error) => {
        console.log("Whoami: error");
        console.log(error);
        this.$store.dispatch("auth/logout");
        this.$router.push("/login/organization");
      });

    UserService.getRequesterComplete()
      .then(
        function (response) {
          // handle success
          this.complete = response.data;
        }.bind(this)
      )
      .catch(
        function (error) {
          // handle error
          this.complete = [];
          console.log(error);
          return !this.stopPropagation;
        }.bind(this)
      );

    UserService.getRequesterQueue()
      .then(
        function (response) {
          // handle success
          // console.log(response);
          this.queue = response.data;
        }.bind(this)
      )
      .catch(
        function (error) {
          // handle error
          this.queue = [];
          console.log(error);
        }.bind(this)
      );

    if(localStorage.dest_lang)
      localStorage.removeItem('dest_lang');
  },
  watch: {
    src_lang: function (val) {
      this.src_lang_id = val.id;
    },
    dest_lang: function (val) {
      this.dest_lang_id = [];
      val.forEach((element) => {
        this.dest_lang_id.push(element.id);
      });
    },
  },
  methods: {
    getQueue(orderBy, asc){
       if(!orderBy && !asc)
          this.axios.get(process.env.VUE_APP_ROOT + "/documents/requester/queue.json", {
            headers: authHeader(),
          }).then((response)=> {this.queue = response.data});
        else{
          const myData = new FormData();
          if(orderBy)
            myData.append("orderBy", orderBy);
          if(asc)
            myData.append("asc", asc);

          this.axios({
            method: "post",
            url: process.env.VUE_APP_ROOT + "/documents/requester/queue.json",
            data: myData,
            headers: authHeader(),
          }).then((response) => (this.queue = response.data));
        }
    },
    getCompleted(orderBy, asc){
        if(!orderBy && !asc)
          this.axios.get(process.env.VUE_APP_ROOT + "/documents/requester/complete.json", {
            headers: authHeader(),
          }).then((response)=> {this.complete = response.data});
        else{
          const myData = new FormData();
          if(orderBy)
            myData.append("orderBy", orderBy);
          if(asc)
            myData.append("asc", asc);

          this.axios({
            method: "post",
            url: process.env.VUE_APP_ROOT + "/documents/requester/complete.json",
            data: myData,
            headers: authHeader(),
          }).then((response) => (this.complete = response.data));
        }
    },
    onFileChange(e) {
      this.$refs.viewFile.value = e.target.files[0].name;
      this.file = e.target.files[0];
    },
    goto(refName) {
      console.log(refName);
      /* var element = this.$refs[refName];

        var top = element.offsetTop;
        window.scrollTo(0, top); */
    },
    onSubmit() {
      this.loading = true;
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.errors.clear();

        var myForm = new FormData();
        myForm.set("requester_id", this.user.id);
        myForm.set("document_type", this.document_type);
        if (this.due_date !== null) {
          myForm.set("due_date", moment(this.due_date).format("YYYY-MM-DD"));
        }
        myForm.set("src_lang_id", this.src_lang_id);
        myForm.set("request_audio", this.request_audio);
        //Devo passarlo così se no non capisce che è un array
        this.app= [];
        for (var i = 0; i < this.dest_lang_id.length; i++) {
          this.app.push(this.dest_lang_id[i]);
        }
        myForm.append("dest_lang_id[]", this.app);

        myForm.set("note", this.note);
        myForm.append("original", this.file);
        this.axios({
          method: "post",
          url: process.env.VUE_APP_ROOT + "/documents/add",
          data: myForm,
          headers: authFileHeader(),
        })
          .then((res) => {
            console.log("Upload success" + res);
            this.errorMessage = "";
            this.errors.clear();

            this.$bvModal.msgBoxOk(
              "Il file è stato caricato con successo. Non resta che attendere la traduzione o caricare un altro file."
            );
            UserService.getRequesterQueue().then((response) => ((this.queue = response.data), (this.loading = false)));
            this.resetForm();
            this.goto("card-queue" + this.queue.length - 1);
          })
          .catch((res) => {
            console.log("Upload failure: " + res.response.data.message);
            this.errorMessage = res.response.data.message;
            UserService.getRequesterQueue().then((response) => ((this.queue = response.data), (this.loading = false)));
          });
      });
    },
    delItem(document_id, element_index) {
      this.$bvModal.msgBoxConfirm("Vuoi davvero cancellare questa richiesta?").then((res) => {
        if (res) {
          UserService.delDoc(document_id).then(() => {
            this.$delete(this.queue, element_index);
          });
        }
      });
    },
    resetForm() {
      this.file = null;
      this.document_type = "";
      this.due_date = "";
      this.src_lang_id = "it";
      this.dest_lang_id = [];
      this.note = "";
      this.src_lang = "Italiano";
      this.dest_lang = [];
    },
    changedLabel(event){
      if(event.length>0)
        if(event[event.length-1].automatic && event[event.length-1].published == false)
          this.$bvModal.show('only-automatic-translate');
    },
    order(type, msg) {
      if(msg){
        if(type == 'queue')
          this.getQueue(this.orderBy, this.asc);
        if(type == 'completed')
          this.getCompleted(this.orderBy, this.asc);
      } else{
        if(type == 'queue')
          this.getQueue();
        if(type == 'completed')
          this.getCompleted();
        
        this.orderBy = null;
        this.asc = 'ASC';
      }
      this.$refs.dropdown.hide(true);
      this.$refs.dropdown2.hide(true);
    },
  },
};
</script>
<style>
.jumbotron {
  background-image: url("/img/bg-org.png");
}
.mask.org {
  background-color: #ff2300;
}
.butFile {
  border-radius: 0 25px 25px 0 !important;
  margin-left: -15px;
  z-index: 0;
  margin-bottom: 2px;
  height: 38px;
}
.btn-outline-primary,
.btn-outline-danger {
  z-index: 1;
}
.border-danger,
.btn-outline-secondary,
.btn-outline-primary,
.btn-outline-danger {
  border-width: 2px !important;
}
</style>
